import { render, staticRenderFns } from "./pointsRanking.vue?vue&type=template&id=4f7357ca&scoped=true&"
import script from "./pointsRanking.vue?vue&type=script&lang=js&"
export * from "./pointsRanking.vue?vue&type=script&lang=js&"
import style0 from "./pointsRanking.vue?vue&type=style&index=0&id=4f7357ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7357ca",
  null
  
)

export default component.exports